import React from "react";

export default function ML_Terminology() {
  return (
    <div>
      <h1>ML_Terminology</h1>
      <p>This is the ML_Terminology component.</p>
    </div>
  );
}
